export const municipalities: Record<string, number> = {
	// DENMARK
	Aabenraa: 1,
	Aalborg: 2,
	Aarhus: 3,
	Albertslund: 5,
	Allerød: 6,
	Assens: 7,
	Ballerup: 8,
	Billund: 9,
	Bornholms: 98,
	Brøndby: 10,
	Brønderslev: 11,
	Dragør: 12,
	Egedal: 13,
	Esbjerg: 14,
	'Faaborg-Midtfyn': 15,
	Fanø: 16,
	Favrskov: 17,
	Faxe: 18,
	Fredensborg: 19,
	Fredericia: 20,
	Frederiksberg: 21,
	Frederikshavn: 22,
	Frederikssund: 23,
	Furesø: 24,
	Gentofte: 25,
	Gladsaxe: 26,
	Glostrup: 27,
	Greve: 28,
	Gribskov: 29,
	Guldborgsund: 30,
	Haderslev: 31,
	Halsnæs: 32,
	Hedensted: 33,
	Helsingør: 34,
	Herlev: 35,
	Herning: 36,
	Hillerød: 37,
	Hjørring: 38,
	Holbæk: 40,
	Holstebro: 41,
	Horsens: 42,
	Hvidovre: 44,
	'Høje-Taastrup': 39,
	Hørsholm: 43,
	'Ikast-Brande': 45,
	Ishøj: 46,
	Jammerbugt: 47,
	Kalundborg: 48,
	Kerteminde: 49,
	Kolding: 52,
	Københavns: 50,
	Køge: 51,
	Langeland: 54,
	Lejre: 55,
	Lemvig: 56,
	Lolland: 57,
	'Lyngby-Taarbæk': 58,
	Læsø: 53,
	Mariagerfjord: 59,
	Middelfart: 60,
	Morsø: 61,
	Norddjurs: 63,
	Nordfyns: 64,
	Nyborg: 65,
	Næstved: 62,
	Odder: 66,
	Odense: 67,
	Odsherred: 68,
	Randers: 69,
	Rebild: 70,
	'Ringkøbing-Skjern': 71,
	Ringsted: 72,
	Roskilde: 74,
	Rudersdal: 75,
	Rødovre: 73,
	Samsø: 76,
	Silkeborg: 77,
	Skanderborg: 78,
	Skive: 79,
	Slagelse: 80,
	Solrød: 81,
	Sorø: 83,
	Stevns: 84,
	Struer: 85,
	Svendborg: 86,
	Syddjurs: 87,
	Sønderborg: 82,
	Thisted: 89,
	Tønder: 90,
	Tårnby: 88,
	Vallensbæk: 91,
	Varde: 92,
	Vejen: 93,
	Vejle: 94,
	Vesthimmerlands: 95,
	Viborg: 96,
	Vordingborg: 97,
	Ærø: 4,

	// SWEDEN
	Ale: 1001,
	Alingsås: 1002,
	Alvesta: 1003,
	Aneby: 1004,
	Arboga: 1005,
	Arjeplog: 1006,
	Arvidsjaur: 1007,
	Arvika: 1008,
	Askersund: 1009,
	Avesta: 1010,
	Bengtsfors: 1011,
	Berg: 1012,
	Bjurholm: 1013,
	Bjuv: 1014,
	Boden: 1015,
	Bollebygd: 1016,
	Bollnäs: 1017,
	Borgholm: 1018,
	Borlänge: 1019,
	Borås: 1020,
	Botkyrka: 1021,
	Boxholm: 1022,
	Bromölla: 1023,
	Bräcke: 1024,
	Burlöv: 1025,
	Båstad: 1026,
	'Dals-Ed': 1027,
	Danderyd: 1028,
	Degerfors: 1029,
	Dorotea: 1030,
	Eda: 1031,
	Ekerö: 1032,
	Eksjö: 1033,
	Emmaboda: 1034,
	Enköping: 1035,
	Eskilstuna: 1036,
	Eslöv: 1037,
	Essunga: 1038,
	Fagersta: 1039,
	Falkenberg: 1040,
	Falköping: 1041,
	Falun: 1042,
	Filipstad: 1043,
	Finspång: 1044,
	Flen: 1045,
	Forshaga: 1046,
	Färgelanda: 1047,
	Gagnef: 1048,
	Gislaved: 1049,
	Gnesta: 1050,
	Gnosjö: 1051,
	Göteborg: 1052,
	Gotland: 1053,
	Grums: 1054,
	Grästorp: 1055,
	Gullspång: 1056,
	Gällivare: 1057,
	Gävle: 1058,
	Götene: 1059,
	Habo: 1060,
	Hagfors: 1061,
	Hallsberg: 1062,
	Hallstahammar: 1063,
	Halmstad: 1064,
	Hammarö: 1065,
	Haninge: 1066,
	Haparanda: 1067,
	Heby: 1068,
	Hedemora: 1069,
	Helsingborg: 1070,
	Herrljunga: 1071,
	Hjo: 1072,
	Hofors: 1073,
	Huddinge: 1074,
	Hudiksvall: 1075,
	Hultsfred: 1076,
	Hylte: 1077,
	Hällefors: 1078,
	Härjedalen: 1079,
	Härnösand: 1080,
	Härryda: 1081,
	Hässleholm: 1082,
	Håbo: 1083,
	Höganäs: 1084,
	Högsby: 1085,
	Hörby: 1086,
	Höör: 1087,
	Jokkmokk: 1088,
	Järfälla: 1089,
	Jönköping: 1090,
	Kalix: 1091,
	Kalmar: 1092,
	Karlsborg: 1093,
	Karlshamn: 1094,
	Karlskoga: 1095,
	Karlskrona: 1096,
	Karlstad: 1097,
	Katrineholm: 1098,
	Kil: 1099,
	Kinda: 1100,
	Kiruna: 1101,
	Klippan: 1102,
	Knivsta: 1103,
	Kramfors: 1104,
	Kristianstad: 1105,
	Kristinehamn: 1106,
	Krokom: 1107,
	Kumla: 1108,
	Kungsbacka: 1109,
	Kungsör: 1110,
	Kungälv: 1111,
	Kävlinge: 1112,
	Köping: 1113,
	Laholm: 1114,
	Landskrona: 1115,
	Laxå: 1116,
	Lekeberg: 1117,
	Leksand: 1118,
	Lerum: 1119,
	Lessebo: 1120,
	Lidingö: 1121,
	Lidköping: 1122,
	'Lilla Edet': 1123,
	Lindesberg: 1124,
	Linköping: 1125,
	Ljungby: 1126,
	Ljusdal: 1127,
	Ljusnarsberg: 1128,
	Lomma: 1129,
	Ludvika: 1130,
	Luleå: 1131,
	Lund: 1132,
	Lycksele: 1133,
	Lysekil: 1134,
	Malmö: 1135,
	'Malung-Sälen': 1136,
	Malå: 1137,
	Mariestad: 1138,
	Mark: 1139,
	Markaryd: 1140,
	Mellerud: 1141,
	Mjölby: 1142,
	Mora: 1143,
	Motala: 1144,
	Mullsjö: 1145,
	Munkedal: 1146,
	Munkfors: 1147,
	Mölndal: 1148,
	Mönsterås: 1149,
	Mörbylånga: 1150,
	Nacka: 1151,
	Nora: 1152,
	Norberg: 1153,
	Nordanstig: 1154,
	Nordmaling: 1155,
	Norrköping: 1156,
	Norrtälje: 1157,
	Norsjö: 1158,
	Nybro: 1159,
	Nykvarn: 1160,
	Nyköping: 1161,
	Nynäshamn: 1162,
	Nässjö: 1163,
	Ockelbo: 1164,
	Olofström: 1165,
	Orsa: 1166,
	Orust: 1167,
	Osby: 1168,
	Oskarshamn: 1169,
	Ovanåker: 1170,
	Oxelösund: 1171,
	Pajala: 1172,
	Partille: 1173,
	Perstorp: 1174,
	Piteå: 1175,
	Ragunda: 1176,
	Robertsfors: 1177,
	Ronneby: 1178,
	Rättvik: 1179,
	Sala: 1180,
	Salem: 1181,
	Sandviken: 1182,
	Sigtuna: 1183,
	Simrishamn: 1184,
	Sjöbo: 1185,
	Skara: 1186,
	Skellefteå: 1187,
	Skinnskatteberg: 1188,
	Skurup: 1189,
	Skövde: 1190,
	Smedjebacken: 1191,
	Sollefteå: 1192,
	Sollentuna: 1193,
	Solna: 1194,
	Sorsele: 1195,
	Sotenäs: 1196,
	Staffanstorp: 1197,
	Stenungsund: 1198,
	Stockholm: 1199,
	Storfors: 1200,
	Storuman: 1201,
	Strängnäs: 1202,
	Strömstad: 1203,
	Strömsund: 1204,
	Sundbyberg: 1205,
	Sundsvall: 1206,
	Sunne: 1207,
	Surahammar: 1208,
	Svalöv: 1209,
	Svedala: 1210,
	Svenljunga: 1211,
	Säffle: 1212,
	Säter: 1213,
	Sävsjö: 1214,
	Söderhamn: 1215,
	Söderköping: 1216,
	Södertälje: 1217,
	Sölvesborg: 1218,
	Tanum: 1219,
	Tibro: 1220,
	Tidaholm: 1221,
	Tierp: 1222,
	Timrå: 1223,
	Tingsryd: 1224,
	Tjörn: 1225,
	Tomelilla: 1226,
	Torsby: 1227,
	Torsås: 1228,
	Tranemo: 1229,
	Tranås: 1230,
	Trelleborg: 1231,
	Trollhättan: 1232,
	Trosa: 1233,
	Tyresö: 1234,
	Täby: 1235,
	Töreboda: 1236,
	Uddevalla: 1237,
	Ulricehamn: 1238,
	Umeå: 1239,
	'Upplands Väsby': 1240,
	'Upplands-Bro': 1241,
	Uppsala: 1242,
	Uppvidinge: 1243,
	Vadstena: 1244,
	Vaggeryd: 1245,
	Valdemarsvik: 1246,
	Vallentuna: 1247,
	Vansbro: 1248,
	Vara: 1249,
	Varberg: 1250,
	Vaxholm: 1251,
	Vellinge: 1252,
	Vetlanda: 1253,
	Vilhelmina: 1254,
	Vimmerby: 1255,
	Vindeln: 1256,
	Vingåker: 1257,
	Vänersborg: 1258,
	Vännäs: 1259,
	Värmdö: 1260,
	Värnamo: 1261,
	Västervik: 1262,
	Västerås: 1263,
	Växjö: 1264,
	Vårgårda: 1265,
	Ydre: 1266,
	Ystad: 1267,
	Älmhult: 1268,
	Älvdalen: 1269,
	Älvkarleby: 1270,
	Älvsbyn: 1271,
	Ängelholm: 1272,
	Åmål: 1273,
	Ånge: 1274,
	Åre: 1275,
	Årjäng: 1276,
	Åsele: 1277,
	Åstorp: 1278,
	Åtvidaberg: 1279,
	Öckerö: 1280,
	Ödeshög: 1281,
	Örebro: 1282,
	Örkelljunga: 1283,
	Örnsköldsvik: 1284,
	Östersund: 1285,
	Österåker: 1286,
	Östhammar: 1287,
	'Östra Göinge': 1288,
	Överkalix: 1289,
	Övertorneå: 1290,

	// GERMANY
	Berlin: 2001,
	Bielefeld: 2002,
	Bochum: 2003,
	Bonn: 2004,
	Bremen: 2005,
	Dortmund: 2006,
	Dresden: 2007,
	Duisburg: 2008,
	Düsseldorf: 2009,
	Essen: 2010,
	Frankfurt: 2011,
	Hamborg: 2012,
	Hannover: 2013,
	Köln: 2014,
	Leipzig: 2015,
	Mannheim: 2016,
	München: 2017,
	Nürnberg: 2018,
	Stuttgart: 2019,
	Wuppertal: 2020,
};

export const regions: Record<string, number[]> = {
	Nordjylland: [
		municipalities['Aalborg'],
		municipalities['Brønderslev'],
		municipalities['Frederikshavn'],
		municipalities['Hjørring'],
		municipalities['Jammerbugt'],
		municipalities['Læsø'],
		municipalities['Mariagerfjord'],
		municipalities['Morsø'],
		municipalities['Rebild'],
		municipalities['Thisted'],
		municipalities['Vesthimmerlands'],
	],

	'Midt-Vestjylland': [
		municipalities['Herning'],
		municipalities['Holstebro'],
		municipalities['Ikast-Brande'],
		municipalities['Lemvig'],
		municipalities['Ringkøbing-Skjern'],
		municipalities['Skive'],
		municipalities['Struer'],
		municipalities['Viborg'],
	],

	'Midt-Østjylland': [
		municipalities['Aarhus'],
		municipalities['Favrskov'],
		municipalities['Hedensted'],
		municipalities['Horsens'],
		municipalities['Norddjurs'],
		municipalities['Odder'],
		municipalities['Randers'],
		municipalities['Samsø'],
		municipalities['Silkeborg'],
		municipalities['Skanderborg'],
		municipalities['Syddjurs'],
	],

	Sønderjylland: [
		municipalities['Aabenraa'],
		municipalities['Billund'],
		municipalities['Tønder'],
		municipalities['Varde'],
		municipalities['Vejen'],
		municipalities['Sønderborg'],
		municipalities['Vejle'],
		municipalities['Esbjerg'],
		municipalities['Fanø'],
		municipalities['Fredericia'],
		municipalities['Haderslev'],
		municipalities['Kolding'],
	],

	Fyn: [
		municipalities['Assens'],
		municipalities['Faaborg-Midtfyn'],
		municipalities['Kerteminde'],
		municipalities['Langeland'],
		municipalities['Middelfart'],
		municipalities['Nordfyns'],
		municipalities['Nyborg'],
		municipalities['Odense'],
		municipalities['Svendborg'],
	],

	Storkøbenhavn: [
		municipalities['Albertslund'],
		municipalities['Ballerup'],
		municipalities['Brøndby'],
		municipalities['Dragør'],
		municipalities['Egedal'],
		municipalities['Frederiksberg'],
		municipalities['Gentofte'],
		municipalities['Gladsaxe'],
		municipalities['Glostrup'],
		municipalities['Herlev'],
		municipalities['Hvidovre'],
		municipalities['Høje-Taastrup'],
		municipalities['Ishøj'],
		municipalities['Københavns'],
		municipalities['Lyngby-Taarbæk'],
		municipalities['Rødovre'],
		municipalities['Tårnby'],
		municipalities['Vallensbæk'],
	],

	Vestegnen: [
		municipalities['Albertslund'],
		municipalities['Brøndby'],
		municipalities['Glostrup'],
		municipalities['Hvidovre'],
		municipalities['Høje-Taastrup'],
		municipalities['Ishøj'],
		municipalities['Rødovre'],
		municipalities['Vallensbæk'],
	],

	Nordsjælland: [
		municipalities['Allerød'],
		municipalities['Egedal'],
		municipalities['Fredensborg'],
		municipalities['Frederikssund'],
		municipalities['Furesø'],
		municipalities['Gribskov'],
		municipalities['Halsnæs'],
		municipalities['Helsingør'],
		municipalities['Hillerød'],
		municipalities['Hørsholm'],
		municipalities['Rudersdal'],
	],

	Sydøstsjælland: [
		municipalities['Faxe'],
		municipalities['Greve'],
		municipalities['Guldborgsund'],
		municipalities['Køge'],
		municipalities['Lejre'],
		municipalities['Lolland'],
		municipalities['Næstved'],
		municipalities['Ringsted'],
		municipalities['Roskilde'],
		municipalities['Solrød'],
		municipalities['Stevns'],
		municipalities['Vordingborg'],
	],

	Vestsjælland: [
		municipalities['Holbæk'],
		municipalities['Kalundborg'],
		municipalities['Odsherred'],
		municipalities['Slagelse'],
		municipalities['Sorø'],
	],
};

export const neighbors: Record<string, number[]> = {
	Albertslund: [
		municipalities['Ballerup'],
		municipalities['Egedal'],
		municipalities['Høje-Taastrup'],
		municipalities['Rødovre'],
		municipalities['Vallensbæk'],
	],

	Allerød: [
		municipalities['Fredensborg'],
		municipalities['Frederikssund'],
		municipalities['Furesø'],
		municipalities['Hillerød'],
		municipalities['Hørsholm'],
		municipalities['Rudersdal'],
	],

	Assens: [
		municipalities['Faaborg-Midtfyn'],
		municipalities['Middelfart'],
		municipalities['Nordfyns'],
		municipalities['Odense'],
	],

	Ballerup: [
		municipalities['Albertslund'],
		municipalities['Egedal'],
		municipalities['Furesø'],
		municipalities['Herlev'],
		municipalities['Rødovre'],
	],

	Billund: [
		municipalities['Herning'],
		municipalities['Ikast-Brande'],
		municipalities['Ringkøbing-Skjern'],
		municipalities['Varde'],
		municipalities['Vejen'],
		municipalities['Vejle'],
	],

	Bornholms: [],

	Brøndby: [
		municipalities['Glostrup'],
		municipalities['Hvidovre'],
		municipalities['Rødovre'],
		municipalities['Vallensbæk'],
	],

	Brønderslev: [
		municipalities['Frederikshavn'],
		municipalities['Hjørring'],
		municipalities['Jammerbugt'],
		municipalities['Aalborg'],
	],

	Dragør: [municipalities['Tårnby']],

	Egedal: [
		municipalities['Albertslund'],
		municipalities['Allerød'],
		municipalities['Ballerup'],
		municipalities['Frederikssund'],
		municipalities['Furesø'],
		municipalities['Høje-Taastrup'],
		municipalities['Roskilde'],
	],

	Esbjerg: [
		municipalities['Fanø'],
		municipalities['Haderslev'],
		municipalities['Tønder'],
		municipalities['Varde'],
		municipalities['Vejen'],
	],

	Fanø: [municipalities['Esbjerg'], municipalities['Varde']],

	Favrskov: [
		municipalities['Randers'],
		municipalities['Silkeborg'],
		municipalities['Skanderborg'],
		municipalities['Syddjurs'],
		municipalities['Viborg'],
		municipalities['Aarhus'],
	],

	Faxe: [
		municipalities['Køge'],
		municipalities['Næstved'],
		municipalities['Ringsted'],
		municipalities['Stevns'],
		municipalities['Vordingborg'],
	],

	Fredensborg: [
		municipalities['Allerød'],
		municipalities['Gribskov'],
		municipalities['Helsingør'],
		municipalities['Hillerød'],
		municipalities['Hørsholm'],
	],

	Fredericia: [municipalities['Kolding'], municipalities['Middelfart'], municipalities['Vejle']],

	Frederiksberg: [
		municipalities['Gentofte'],
		municipalities['Gladsaxe'],
		municipalities['Hvidovre'],
		municipalities['Københavns'],
		municipalities['Rødovre'],
		municipalities['Tårnby'],
	],

	Frederikshavn: [municipalities['Brønderslev'], municipalities['Hjørring']],

	Frederikssund: [
		municipalities['Allerød'],
		municipalities['Egedal'],
		municipalities['Halsnæs'],
		municipalities['Hillerød'],
		municipalities['Lejre'],
	],

	Furesø: [
		municipalities['Allerød'],
		municipalities['Ballerup'],
		municipalities['Egedal'],
		municipalities['Gladsaxe'],
		municipalities['Herlev'],
		municipalities['Lyngby-Taarbæk'],
		municipalities['Rudersdal'],
	],

	'Faaborg-Midtfyn': [
		municipalities['Assens'],
		municipalities['Kerteminde'],
		municipalities['Nyborg'],
		municipalities['Odense'],
		municipalities['Svendborg'],
	],

	Gentofte: [
		municipalities['Frederiksberg'],
		municipalities['Gladsaxe'],
		municipalities['Københavns'],
		municipalities['Lyngby-Taarbæk'],
	],

	Gladsaxe: [
		municipalities['Frederiksberg'],
		municipalities['Furesø'],
		municipalities['Gentofte'],
		municipalities['Herlev'],
		municipalities['Københavns'],
		municipalities['Lyngby-Taarbæk'],
	],

	Glostrup: [
		municipalities['Brøndby'],
		municipalities['Herlev'],
		municipalities['Hvidovre'],
		municipalities['Københavns'],
		municipalities['Rødovre'],
	],

	Greve: [municipalities['Ishøj'], municipalities['Roskilde'], municipalities['Solrød']],

	Gribskov: [
		municipalities['Fredensborg'],
		municipalities['Halsnæs'],
		municipalities['Helsingør'],
		municipalities['Hillerød'],
	],

	Guldborgsund: [municipalities['Lolland'], municipalities['Vordingborg']],

	Haderslev: [
		municipalities['Esbjerg'],
		municipalities['Kolding'],
		municipalities['Tønder'],
		municipalities['Vejen'],
		municipalities['Aabenraa'],
	],

	Halsnæs: [
		municipalities['Frederikssund'],
		municipalities['Gribskov'],
		municipalities['Hillerød'],
	],
	Hedensted: [municipalities['Horsens'], municipalities['Ikast-Brande'], municipalities['Vejle']],
	Helsingør: [municipalities['Fredensborg'], municipalities['Gribskov']],

	Herlev: [
		municipalities['Ballerup'],
		municipalities['Furesø'],
		municipalities['Gladsaxe'],
		municipalities['Glostrup'],
	],

	Herning: [
		municipalities['Billund'],
		municipalities['Holstebro'],
		municipalities['Ikast-Brande'],
		municipalities['Ringkøbing-Skjern'],
		municipalities['Viborg'],
	],

	Hillerød: [
		municipalities['Allerød'],
		municipalities['Fredensborg'],
		municipalities['Frederikssund'],
		municipalities['Gribskov'],
		municipalities['Halsnæs'],
	],

	Hjørring: [
		municipalities['Brønderslev'],
		municipalities['Frederikshavn'],
		municipalities['Jammerbugt'],
	],

	Holbæk: [
		municipalities['Kalundborg'],
		municipalities['Lejre'],
		municipalities['Odsherred'],
		municipalities['Ringsted'],
		municipalities['Sorø'],
	],

	Holstebro: [
		municipalities['Herning'],
		municipalities['Lemvig'],
		municipalities['Ringkøbing-Skjern'],
		municipalities['Skive'],
		municipalities['Struer'],
		municipalities['Viborg'],
	],

	Horsens: [
		municipalities['Hedensted'],
		municipalities['Ikast-Brande'],
		municipalities['Odder'],
		municipalities['Silkeborg'],
		municipalities['Skanderborg'],
	],

	Hvidovre: [
		municipalities['Brøndby'],
		municipalities['Frederiksberg'],
		municipalities['Glostrup'],
		municipalities['Københavns'],
		municipalities['Rødovre'],
		municipalities['Tårnby'],
	],

	'Høje-Taastrup': [
		municipalities['Albertslund'],
		municipalities['Egedal'],
		municipalities['Ishøj'],
		municipalities['Roskilde'],
		municipalities['Vallensbæk'],
	],

	Hørsholm: [
		municipalities['Allerød'],
		municipalities['Fredensborg'],
		municipalities['Rudersdal'],
	],

	'Ikast-Brande': [
		municipalities['Billund'],
		municipalities['Herning'],
		municipalities['Horsens'],
		municipalities['Silkeborg'],
		municipalities['Vejle'],
		municipalities['Viborg'],
	],

	Ishøj: [municipalities['Greve'], municipalities['Høje-Taastrup'], municipalities['Vallensbæk']],

	Jammerbugt: [
		municipalities['Brønderslev'],
		municipalities['Hjørring'],
		municipalities['Thisted'],
		municipalities['Vesthimmerlands'],
		municipalities['Aalborg'],
	],

	Kalundborg: [
		municipalities['Holbæk'],
		municipalities['Odsherred'],
		municipalities['Slagelse'],
		municipalities['Sorø'],
	],

	Kerteminde: [
		municipalities['Faaborg-Midtfyn'],
		municipalities['Nyborg'],
		municipalities['Odense'],
	],

	Kolding: [
		municipalities['Fredericia'],
		municipalities['Haderslev'],
		municipalities['Vejen'],
		municipalities['Vejle'],
	],

	Københavns: [
		municipalities['Frederiksberg'],
		municipalities['Gentofte'],
		municipalities['Gladsaxe'],
		municipalities['Rødovre'],
		municipalities['Hvidovre'],
		municipalities['Tårnby'],
	],

	Køge: [
		municipalities['Faxe'],
		municipalities['Lejre'],
		municipalities['Ringsted'],
		municipalities['Roskilde'],
		municipalities['Solrød'],
		municipalities['Stevns'],
	],

	Langeland: [municipalities['Svendborg'], municipalities['Ærø']],

	Lejre: [
		municipalities['Frederikssund'],
		municipalities['Holbæk'],
		municipalities['Køge'],
		municipalities['Ringsted'],
		municipalities['Roskilde'],
	],

	Lemvig: [municipalities['Holstebro'], municipalities['Struer'], municipalities['Thisted']],
	Lolland: [municipalities['Guldborgsund']],

	'Lyngby-Taarbæk': [
		municipalities['Furesø'],
		municipalities['Gentofte'],
		municipalities['Gladsaxe'],
		municipalities['Rudersdal'],
	],

	Læsø: [],

	Mariagerfjord: [
		municipalities['Randers'],
		municipalities['Rebild'],
		municipalities['Vesthimmerlands'],
		municipalities['Viborg'],
		municipalities['Aalborg'],
	],

	Middelfart: [
		municipalities['Assens'],
		municipalities['Fredericia'],
		municipalities['Nordfyns'],
	],
	Morsø: [municipalities['Skive'], municipalities['Struer'], municipalities['Thisted']],
	Norddjurs: [municipalities['Randers'], municipalities['Syddjurs']],
	Nordfyns: [municipalities['Assens'], municipalities['Middelfart'], municipalities['Odense']],
	Nyborg: [
		municipalities['Faaborg-Midtfyn'],
		municipalities['Kerteminde'],
		municipalities['Svendborg'],
	],

	Næstved: [
		municipalities['Faxe'],
		municipalities['Ringsted'],
		municipalities['Slagelse'],
		municipalities['Sorø'],
		municipalities['Vordingborg'],
	],

	Odder: [municipalities['Horsens'], municipalities['Skanderborg'], municipalities['Aarhus']],

	Odense: [
		municipalities['Assens'],
		municipalities['Faaborg-Midtfyn'],
		municipalities['Kerteminde'],
		municipalities['Nordfyns'],
	],

	Odsherred: [municipalities['Holbæk'], municipalities['Kalundborg']],

	Randers: [
		municipalities['Favrskov'],
		municipalities['Mariagerfjord'],
		municipalities['Norddjurs'],
		municipalities['Syddjurs'],
		municipalities['Viborg'],
	],

	Rebild: [
		municipalities['Mariagerfjord'],
		municipalities['Vesthimmerlands'],
		municipalities['Aalborg'],
	],

	'Ringkøbing-Skjern': [
		municipalities['Billund'],
		municipalities['Herning'],
		municipalities['Holstebro'],
		municipalities['Varde'],
	],

	Ringsted: [
		municipalities['Faxe'],
		municipalities['Holbæk'],
		municipalities['Køge'],
		municipalities['Lejre'],
		municipalities['Næstved'],
		municipalities['Sorø'],
	],

	Roskilde: [
		municipalities['Egedal'],
		municipalities['Greve'],
		municipalities['Høje-Taastrup'],
		municipalities['Køge'],
		municipalities['Lejre'],
		municipalities['Solrød'],
	],

	Rudersdal: [
		municipalities['Allerød'],
		municipalities['Furesø'],
		municipalities['Hørsholm'],
		municipalities['Lyngby-Taarbæk'],
	],

	Rødovre: [
		municipalities['Albertslund'],
		municipalities['Ballerup'],
		municipalities['Brøndby'],
		municipalities['Frederiksberg'],
		municipalities['Glostrup'],
		municipalities['Herlev'],
		municipalities['Hvidovre'],
	],

	Samsø: [municipalities['Kalundborg'], municipalities['Odder']],

	Silkeborg: [
		municipalities['Favrskov'],
		municipalities['Horsens'],
		municipalities['Ikast-Brande'],
		municipalities['Skanderborg'],
		municipalities['Viborg'],
	],

	Skanderborg: [
		municipalities['Favrskov'],
		municipalities['Horsens'],
		municipalities['Odder'],
		municipalities['Silkeborg'],
		municipalities['Aarhus'],
	],

	Skive: [
		municipalities['Holstebro'],
		municipalities['Morsø'],
		municipalities['Struer'],
		municipalities['Thisted'],
		municipalities['Vesthimmerlands'],
		municipalities['Viborg'],
	],

	Slagelse: [municipalities['Kalundborg'], municipalities['Næstved'], municipalities['Sorø']],
	Solrød: [municipalities['Greve'], municipalities['Køge'], municipalities['Roskilde']],

	Sorø: [
		municipalities['Holbæk'],
		municipalities['Kalundborg'],
		municipalities['Næstved'],
		municipalities['Ringsted'],
		municipalities['Slagelse'],
	],

	Stevns: [municipalities['Faxe'], municipalities['Køge']],
	Struer: [
		municipalities['Holstebro'],
		municipalities['Lemvig'],
		municipalities['Skive'],
		municipalities['Thisted'],
	],

	Svendborg: [
		municipalities['Faaborg-Midtfyn'],
		municipalities['Langeland'],
		municipalities['Nyborg'],
		municipalities['Ærø'],
	],

	Syddjurs: [
		municipalities['Favrskov'],
		municipalities['Norddjurs'],
		municipalities['Randers'],
		municipalities['Aarhus'],
	],

	Sønderborg: [municipalities['Aabenraa'], municipalities['Ærø']],

	Thisted: [
		municipalities['Jammerbugt'],
		municipalities['Lemvig'],
		municipalities['Morsø'],
		municipalities['Skive'],
		municipalities['Struer'],
	],

	Tønder: [municipalities['Esbjerg'], municipalities['Haderslev'], municipalities['Aabenraa']],

	Tårnby: [
		municipalities['Dragør'],
		municipalities['Frederiksberg'],
		municipalities['Hvidovre'],
		municipalities['Københavns'],
	],

	Vallensbæk: [
		municipalities['Albertslund'],
		municipalities['Brøndby'],
		municipalities['Høje-Taastrup'],
		municipalities['Ishøj'],
	],

	Varde: [
		municipalities['Billund'],
		municipalities['Esbjerg'],
		municipalities['Fanø'],
		municipalities['Ringkøbing-Skjern'],
		municipalities['Vejen'],
	],

	Vejen: [
		municipalities['Billund'],
		municipalities['Esbjerg'],
		municipalities['Haderslev'],
		municipalities['Kolding'],
		municipalities['Varde'],
		municipalities['Vejle'],
	],

	Vejle: [
		municipalities['Billund'],
		municipalities['Fredericia'],
		municipalities['Hedensted'],
		municipalities['Ikast-Brande'],
		municipalities['Kolding'],
		municipalities['Vejen'],
	],

	Vesthimmerlands: [
		municipalities['Jammerbugt'],
		municipalities['Mariagerfjord'],
		municipalities['Rebild'],
		municipalities['Skive'],
		municipalities['Viborg'],
		municipalities['Aalborg'],
	],

	Viborg: [
		municipalities['Favrskov'],
		municipalities['Ikast-Brande'],
		municipalities['Herning'],
		municipalities['Holstebro'],
		municipalities['Mariagerfjord'],
		municipalities['Randers'],
		municipalities['Silkeborg'],
		municipalities['Skive'],
		municipalities['Vesthimmerlands'],
	],
	Vordingborg: [
		municipalities['Faxe'],
		municipalities['Guldborgsund'],
		municipalities['Næstved'],
	],
	Ærø: [municipalities['Langeland'], municipalities['Svendborg'], municipalities['Sønderborg']],
	Aabenraa: [municipalities['Haderslev'], municipalities['Sønderborg'], municipalities['Tønder']],

	Aalborg: [
		municipalities['Brønderslev'],
		municipalities['Jammerbugt'],
		municipalities['Mariagerfjord'],
		municipalities['Rebild'],
		municipalities['Vesthimmerlands'],
	],

	Aarhus: [
		municipalities['Favrskov'],
		municipalities['Odder'],
		municipalities['Skanderborg'],
		municipalities['Syddjurs'],
	],

	// ##### SKÅNE #####

	Bjuv: [
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Bromölla: [
		municipalities['Bjuv'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Burlöv: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Båstad: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Eslöv: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Helsingborg: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Hässleholm: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Höganäs: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Hörby: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Höör: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Klippan: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Kristianstad: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Kävlinge: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Landskrona: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Lomma: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Lund: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Malmö: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Osby: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Perstorp: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Simrishamn: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Sjöbo: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Skurup: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Staffanstorp: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Svalöv: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Svedala: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Tomelilla: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Trelleborg: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Vellinge: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Ystad: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Ängelholm: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	Örkelljunga: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Östra Göinge'],
		municipalities['Åstorp'],
	],

	'Östra Göinge': [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Åstorp'],
	],

	Åstorp: [
		municipalities['Bjuv'],
		municipalities['Bromölla'],
		municipalities['Burlöv'],
		municipalities['Båstad'],
		municipalities['Eslöv'],
		municipalities['Helsingborg'],
		municipalities['Hässleholm'],
		municipalities['Höganäs'],
		municipalities['Hörby'],
		municipalities['Höör'],
		municipalities['Klippan'],
		municipalities['Kristianstad'],
		municipalities['Kävlinge'],
		municipalities['Landskrona'],
		municipalities['Lomma'],
		municipalities['Lund'],
		municipalities['Malmö'],
		municipalities['Osby'],
		municipalities['Perstorp'],
		municipalities['Simrishamn'],
		municipalities['Sjöbo'],
		municipalities['Skurup'],
		municipalities['Staffanstorp'],
		municipalities['Svalöv'],
		municipalities['Svedala'],
		municipalities['Tomelilla'],
		municipalities['Trelleborg'],
		municipalities['Vellinge'],
		municipalities['Ystad'],
		municipalities['Ängelholm'],
		municipalities['Örkelljunga'],
		municipalities['Östra Göinge'],
	],

	// ##### STOCKHOLM #####

	Botkyrka: [
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Danderyd: [
		municipalities['Botkyrka'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Ekerö: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Enköping: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Haninge: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Huddinge: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Håbo: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Järfälla: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Knivsta: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Lidingö: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Nacka: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Norrtälje: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Nykvarn: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Nynäshamn: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Salem: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Sigtuna: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Sollentuna: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Solna: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Stockholm: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Strängnäs: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Sundbyberg: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Södertälje: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Tyresö: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Täby: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	'Upplands Väsby': [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	'Upplands-Bro': [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Uppsala: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Vallentuna: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Vaxholm: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Värmdö'],
		municipalities['Österåker'],
	],

	Värmdö: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Österåker'],
	],

	Österåker: [
		municipalities['Botkyrka'],
		municipalities['Danderyd'],
		municipalities['Ekerö'],
		municipalities['Enköping'],
		municipalities['Gnesta'],
		municipalities['Haninge'],
		municipalities['Huddinge'],
		municipalities['Håbo'],
		municipalities['Järfälla'],
		municipalities['Knivsta'],
		municipalities['Lidingö'],
		municipalities['Nacka'],
		municipalities['Norrtälje'],
		municipalities['Nykvarn'],
		municipalities['Nynäshamn'],
		municipalities['Salem'],
		municipalities['Sigtuna'],
		municipalities['Sollentuna'],
		municipalities['Solna'],
		municipalities['Stockholm'],
		municipalities['Strängnäs'],
		municipalities['Sundbyberg'],
		municipalities['Södertälje'],
		municipalities['Trosa'],
		municipalities['Tyresö'],
		municipalities['Täby'],
		municipalities['Upplands Väsby'],
		municipalities['Upplands-Bro'],
		municipalities['Uppsala'],
		municipalities['Vallentuna'],
		municipalities['Vaxholm'],
		municipalities['Värmdö'],
	],

	// ##### GÖTEBORG #####

	Ale: [
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Alingsås: [
		municipalities['Ale'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Bengtsfors: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Bollebygd: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Borås: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	'Dals-Ed': [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Essunga: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Falköping: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Färgelanda: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Grästorp: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Gullspång: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Göteborg: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Götene: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Herrljunga: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Hjo: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Härryda: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Karlsborg: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Kungälv: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Lerum: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Lidköping: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	'Lilla Edet': [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Lysekil: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Mariestad: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Mark: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Mellerud: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Munkedal: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Mölndal: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Orust: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Partille: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Skara: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Skövde: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Sotenäs: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Stenungsund: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Strömstad: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Svenljunga: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Tanum: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Tibro: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Tidaholm: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Tjörn: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Tranemo: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Trollhättan: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Töreboda: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Uddevalla: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Ulricehamn: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Vara: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Vänersborg: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Vårgårda: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Öckerö'],
		municipalities['Åmål'],
	],

	Öckerö: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Åmål'],
	],

	Åmål: [
		municipalities['Ale'],
		municipalities['Alingsås'],
		municipalities['Bengtsfors'],
		municipalities['Bollebygd'],
		municipalities['Borås'],
		municipalities['Dals-Ed'],
		municipalities['Essunga'],
		municipalities['Falkenberg'],
		municipalities['Falköping'],
		municipalities['Färgelanda'],
		municipalities['Grästorp'],
		municipalities['Gullspång'],
		municipalities['Göteborg'],
		municipalities['Götene'],
		municipalities['Herrljunga'],
		municipalities['Hjo'],
		municipalities['Härryda'],
		municipalities['Karlsborg'],
		municipalities['Kungsbacka'],
		municipalities['Kungälv'],
		municipalities['Lerum'],
		municipalities['Lidköping'],
		municipalities['Lilla Edet'],
		municipalities['Lysekil'],
		municipalities['Mariestad'],
		municipalities['Mark'],
		municipalities['Mellerud'],
		municipalities['Munkedal'],
		municipalities['Mölndal'],
		municipalities['Orust'],
		municipalities['Partille'],
		municipalities['Skara'],
		municipalities['Skövde'],
		municipalities['Sotenäs'],
		municipalities['Stenungsund'],
		municipalities['Strömstad'],
		municipalities['Svenljunga'],
		municipalities['Tanum'],
		municipalities['Tibro'],
		municipalities['Tidaholm'],
		municipalities['Tjörn'],
		municipalities['Tranemo'],
		municipalities['Trollhättan'],
		municipalities['Töreboda'],
		municipalities['Uddevalla'],
		municipalities['Ulricehamn'],
		municipalities['Vara'],
		municipalities['Varberg'],
		municipalities['Vänersborg'],
		municipalities['Vårgårda'],
		municipalities['Öckerö'],
	],
};
